<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="课时名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入课时名称"
              v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入课时名称!' }],initialValue:info.title}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="摘要" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-textarea placeholder="请输入摘要" v-model="info.abstracts" :rows="4" />
          </a-form-item>
          <a-form-item label="图片" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-upload
              :action="$api.file.uploadFile"
              listType="picture-card"
              :fileList="fileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>建议尺寸:260像素*160像素
          </a-form-item>
          <a-form-item label="视频类型" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-select
              :defaultValue="0"
              @change="videoSourceTypeChanged"
              v-decorator="[
              'videoSourceType',
              {rules: [],initialValue:info.videoSourceType}
            ]"
            >
              <a-select-option :value="0">文件</a-select-option>
              <a-select-option :value="1">链接</a-select-option>
              <a-select-option :value="2">第三方-获得场景</a-select-option>
              <a-select-option :value="3">第三方-国开大学</a-select-option>
              <a-select-option :value="4">第三方-爱迪科森</a-select-option>
              <a-select-option :value="5">第三方-安徽课程</a-select-option>
              <a-select-option :value="6">第三方-联安众课程</a-select-option>
              <a-select-option :value="7">第三方-朗坤平台课程</a-select-option>
              <a-select-option :value="10">第三方-中经网</a-select-option>
              <a-select-option :value="11">第三方-课通云</a-select-option>
              <a-select-option :value="17">第三方-国开泛在</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="视频"
            v-if="info.videoSourceType==0"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 19 }"
          >
            <a-upload
              :action="$api.file.uploadFile"
               :customRequest="onFileChange"
               :fileList="fileListVideo"
                listType="picture-card"
                @preview="handleVideoPreview"
                @change="handleVideoChange"
            >
              <div v-if="fileListVideo.length <1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVideoVisible" :footer="null" @cancel="handleVideoCancel">
              <img alt="example" style="width: 100%" :src="previewVideo" />
            </a-modal>
          </a-form-item>
          <a-form-item
            label="视频地址"
            v-if="info.videoSourceType==1"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 19 }"
          >
            <a-input
              placeholder="请输入视频地址"
              v-decorator="[
          'uploadUrl',
          {rules: [{ required: false, message: '请输入视频地址!' }],initialValue:info.uploadUrl}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item
              label="第三方资源"
              v-if="info.videoSourceType==2 || info.videoSourceType == 3|| info.videoSourceType == 4|| info.videoSourceType == 10||info.videoSourceType == 5 ||info.videoSourceType == 6 || info.videoSourceType == 11 || info.videoSourceType == 17"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 19 }"
          >
            <a-input
                placeholder="请输入第三方资源"
                v-decorator="[
          'pageUrl',
          {rules: [{ required: false, message: '请输入第三方资源!' }],initialValue:info.pageUrl}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="详情" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <quill-editor
              v-model="info.content"
              :options="editorOption"
              ref="QuillEditor"
              class="ql-editor"
            ></quill-editor>
          </a-form-item>

          <a-form-item label="播放量" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入播放量"
              v-decorator="[
          'hits',
          {rules: [{ required: false, message: '请输入播放量!' }],initialValue:info.hits}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="时长" :label-col="{ span: 4 }" :wrapper-col="{ span: 5 }">
            <a-input
              placeholder="请输入时长"
              suffix="秒"
              v-decorator="[
          'hourCount',
          {rules: [{ required: false, message: '请输入时长!' }],initialValue:info.hourCount}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="学时" :label-col="{ span: 4 }" :wrapper-col="{ span: 5 }">
            <a-tooltip>
              <template slot="title">学时必须为整数</template>

              <a-input
                placeholder="请输入学时"
                v-decorator="[
          'courseHourCount',
          {rules: [{ required: true, message: '请输入学时!' }],initialValue:info.courseHourCount}
        ]"
              />
            </a-tooltip>
          </a-form-item>
          <a-upload
            name="file"
            :multiple="true"
            :action="$api.system.file.uploadFile"
            @change="handletxtChange"
            class="uploadImage"
            style="display:none"
          >
            <a-button>
              <a-icon type="upload" />Click to Upload
            </a-button>
          </a-upload>
          <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;
var thisInfo = [];
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  //[{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  //[{ size: ["small", false, "large", "huge"] }], // custom dropdown
  //[{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  //[{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"],
  ["clean"], // remove formatting button
];
export default {
  props: {
    id: String, //课程id
    ksId: Number, //课时id,0添加反之编辑
    zjid: Number, //章节idm,0直接添加课时，反之添加章节下的课时
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        videoSourceType: 0,
        hourCount:0,
      },
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      fileListVideo: [],
      previewVisible: false,
      previewVideoVisible: false,
      previewImage: "",
      picArr: [],
      videoArr: [],
      previewVideo: "",
      //富文本
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector(".uploadImage input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
       videoId: '',
        requestId: '',
        uploadAddress: '',
        uploadAuth: null,
        myUploader: null,
        uploadProgress: '',
        textarea: '',
        VideoForm:[],
        videoTimer:null,
    };
  },
  components: {},
  mounted() {
    this.$nextTick(function () {
      that = this;
      if (this.ksId != 0) {
        //编辑
        this.getInfo();
      }
    });
  },
  methods: {
        //2021 09 17
         onFileChange(files) {
                const fileChooser = files
                if (fileChooser.file) {

                    const file = fileChooser.file
                    const fileName = file.name
                    this.VideoForm.fileName = fileName
                    this.VideoForm.title = fileName.substring(0, fileName.lastIndexOf('.'))
                    this.VideoForm.cate = 0
                    this.VideoForm.tags = ''
                    this.$api.course.doGetUploadVideo(this.VideoForm.title,this.VideoForm.fileName).then((res) => {
                    　　if (res.errorCode === '0000') {
                    　　　　this.videoId = res.data.videoId
                    　　　　this.requestId = res.data.requestId
                    　　　　this.uploadAddress = res.data.uploadAddress
                    　　　　this.uploadAuth = res.data.uploadAuth

                            this.getUpload(file)

                    　　} else {
                            this.$message.success('获取上传认证失败!');
                    　　}
                    })


                }


              },
          isVodMode() {
            return (this.uploadAuth && this.uploadAuth.length > 0)
          },
          getUpload(file) {

            if (this.myUploader === null) {
              /* eslint no-undef: "off" */
              this.myUploader = new AliyunUpload.Vod({
                 userId:"122",
                // 分片大小默认1M
                partSize: 1048576,
                // 并行上传分片个数，默认5
                parallel: 5,
                // 网络原因失败时，重新上传次数，默认为3
                retryCount: 3,
                // 网络原因失败时，重新上传间隔时间，默认为2秒
                retryDuration: 2,
                // 文件上传失败
                'onUploadFailed': (uploadInfo, code, message) => {
                    this.$message.error('视频上传失败');

                },
                // 文件上传完成
                'onUploadSucceed': (uploadInfo) => {
                    var _this=this;
                    this.isloading=true;
                        this.loadingTip="转码中...";
                        this.videoTimer = setInterval(res => {
                            if(_this.getVideoInfo()){
                                _this.$message.success('视频上传成功!');
                            }
                        },2000)

                  // _this._doContinueAdd() // --------------上传成功后，把数据给后台
                },
                // 文件上传进度
                'onUploadProgress': (uploadInfo, totalSize, loadedPercent) => {
                    var fileitem=this.fileListVideo[0];
                    fileitem.percent=Math.ceil(loadedPercent * 100);
                    this.fileListVideo[0]=fileitem;

                  console.log('onUploadProgress:file:' + uploadInfo.file.name + ', fileSize:' + totalSize + ', percent:' + Math.ceil(loadedPercent * 100) + '%')

                },
                // STS临时账号会过期，过期时触发函数
                'onUploadTokenExpired': () => {
                  this.log('onUploadTokenExpired')
                  if (this.isVodMode()) {
                    // 实现时，从新获取UploadAuth
                    this.myUploader.resumeUploadWithAuth(this.uploadAuth)
                  }
                },
                // 开始上传
                'onUploadstarted': (uploadInfo) => {
                    console.log('开始上传');
                  if (this.isVodMode()) {
                    this.myUploader.setUploadAuthAndAddress(uploadInfo,
                      this.uploadAuth, this.uploadAddress)
                  }
                  console.log('onUploadStarted:' + uploadInfo.file.name + ', endpoint:' + uploadInfo.endpoint + ', bucket:" + uploadInfo.bucket + ", object:' + uploadInfo.object + uploadInfo.userDate)
                }
              })
            }
            if (this.isVodMode()) {
              this.myUploader.init() // 点播上传。每次上传都是独立的鉴权，所以初始化时，不需要设置鉴权
            }
            var userData = '{"Vod":{}}'
            // 点播上传。每次上传都是独立的OSS object，所以添加文件时，不需要设置OSS的属性
            // console.log(this.myUploader.addFile);
            this.myUploader.addFile(file, null, null, null, userData)
            console.log('开始上传---');
            this.myUploader.startUpload()
          },
          getVideoInfo(){
             this.$api.course.getVideoInfo(this.videoId).then((res) => {
            　　if (res.errorCode === '0000') {
                    var fileitem=this.fileListVideo[0];
                    this.videoArr = [];
                    fileitem.url=res.data.playURL;
                    fileitem.percent=100;
                    fileitem.status='done';
                    this.fileListVideo[0]=fileitem;
                    this.isloading=false;
                    this.loadingTip="加载中...";

                  if(res.data){
                    this.info.hourCount=parseInt(res.data.duration);
                  }
                  clearInterval(this.videoTimer);
                  return true;
            　　}
            })
          },
        // 2021 09 17 end
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    videoSourceTypeChanged(v) {
      this.info.videoSourceType = v;
    },
    /**获取详情 */
    getInfo() {
      this.isloading = true;
      this.$api.classhour
        .getById(this.ksId)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            console.log("--classhour/getById--->",res.data,res.data.videoId);
            this.videoId=res.data.videoId;
            if (res.data.picUrl.length > 0) {
              var pics = res.data.picUrl.split(",");
              for (var i = 0; i < pics.length; i++) {
                this.fileList.push({
                  uid: i,
                  name: "课时图片" + (i + 1) + ".png",
                  status: "done",
                  url: pics[i],
                });
              }
            }

            if (res.data.videoUrl) {
              var videos = res.data.videoUrl.split(",");
              for (var i = 0; i < videos.length; i++) {
                this.fileListVideo.push({
                  uid: i,
                  name: "课时视频" + (i + 1) + ".png",
                  status: "done",
                  url: videos[i],
                });
              }
            // 2021 09 22 start
            }else{
                if(res.data.videoId.length > 1){
                    this.getVideoInfo();
                }
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.picArr = [];
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].url) {
          this.picArr.push(this.fileList[i].url);
        } else if (this.fileList[i].response.data.path) {
          this.picArr.push(this.fileList[i].response.data.path);
        }
      }
      this.videoArr = [];
      for (var i = 0; i < this.fileListVideo.length; i++) {
        if (this.fileListVideo[i].url) {
          this.videoArr.push(this.fileListVideo[i].url);
        } else if (this.fileListVideo[i].response.data.path) {
          this.videoArr.push(this.fileListVideo[i].response.data.path);
        }
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.videoSourceType == 0 && this.videoArr.length == 0) {
            this.error("请上传视频文件");
            return;
          }
          if (this.ksId != 0) {
            //修改
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.classhour
              .update(
                this.ksId,
                1,
                values.title,
                this.info.abstracts ? this.info.abstracts : "",
                this.picArr ? this.picArr.join(",") : "",
                this.videoArr ? this.videoArr.join(",") : "",
                this.info.content ? this.info.content : "",
                values.uploadUrl ? values.uploadUrl : "",
                values.pageUrl ? values.pageUrl : "",
                values.hits ? values.hits : "",
                values.hourCount ? values.hourCount : this.info.hourCount,
                this.zjid == null ? 0 : this.zjid,
                this.id,
                this.info.videoSourceType,
                values.courseHourCount ? values.courseHourCount : "",
                this.videoId ? this.videoId : 0,// 2021 09 22
              )
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            console.log("添加按钮");
            //添加
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.classhour
              .save(
                1,
                values.title,
                this.info.abstracts ? this.info.abstracts : "",
                this.picArr ? this.picArr.join(",") : "",
                this.videoArr ? this.videoArr.join(",") : "",
                this.info.content ? this.info.content : "",
                values.uploadUrl ? values.uploadUrl : "",
                values.pageUrl ? values.pageUrl : "",
                values.hits ? values.hits : "",
                values.hourCount ? values.hourCount : this.info.hourCount,
                this.zjid == null ? 0 : this.zjid,
                this.id,
                this.info.videoSourceType,
                values.courseHourCount ? values.courseHourCount : "",
                this.videoId ? this.videoId : 0,// 2021 09 22
              )
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
            // this.$emit("callbackMethod",values.name);
          }
        }
      });
    },
    onChange() {
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        },
      });
    },
    /**富文本上传图片 */
    handletxtChange(info) {
      if (info.file.status == "done") {
        if (info.file.response.errorCode == this.$msg.responseCode.success) {
          // 获取富文本组件实例
          let quill = this.$refs.QuillEditor.quill;
          // 如果上传成功
          if (info.file.response.data.path) {
            // 获取光标所在位置
            let length = quill.getSelection().index;
            // 插入图片，res为服务器返回的图片链接地址
            quill.insertEmbed(length, "image", info.file.response.data.path);
            // 调整光标到最后
            quill.setSelection(length + 1);
          } else {
            // 提示信息，需引入Message
            Message.error("图片插入失败");
          }
        }
      }
    },

    /**上传课程图片 */
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      this.fileList = info.fileList;
    },

    /**上传课程视频 */
    handleVideoCancel() {
      this.previewVideoVisible = false;
    },
    beforeUpload(file) {
      // const isMP4 = true;
      // const isLt1G=true;
      const isMP4 = file.type === "video/mp4";
      if (!isMP4) {
        this.$message.error("You can only upload MP4 file!");
      }
      const isLt1G = file.size / 1024 / 1024 < 1024;
      if (!isLt1G) {
        this.$message.error("Image must smaller than 1GB!");
      }
      return isMP4 && isLt1G;
    },
    handleVideoPreview(file) {
      this.previewVideo = file.url || file.thumbUrl;
      this.previewVideoVisible = true;
    },
    handleVideoChange(info) {
      this.fileListVideo = info.fileList;
      if (info.file.status == "done") {
        if (info.file.response.errorCode == "0000") {
          this.form.setFieldsValue({
            hourCount: info.file.response.data.duration,
          });
        } else {
          this.error("上传失败");
        }
      } else if (info.file.status == "error") {
        this.error("上传失败");
      }
    },
  },
};
</script>
<style>
</style>
